import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getIntegrationVideoStyles =
    (isGuideCollapsed?: boolean) =>
    (theme: Theme): SerializedStyles =>
        css({
            ...(isGuideCollapsed && { marginTop: theme.spacing(2) }),
        });
